export default __webpack_public_path__ + "static/media/pixellab--web-design--03a--1200x900.81e78f85.jpg";